let videoObj;

export class VideoBlock {
    constructor() {
        this.$videoBlock = App.H.find('.js-video-block');
        this.$videoBlockPause = this.$videoBlock.find('.js-video-block-pause');
        this.$progressBar = this.$videoBlock.find('.js-video-block-progress');
        this.$progressLine = this.$videoBlock.find('.js-video-block-progress-line');
        this.$progressBuffer = this.$videoBlock.find('.js-video-block-progress-buffer');
        this.$videoContainer = this.$videoBlock.find('.js-video-block-container');
        this.$videoBlockImage = this.$videoBlock.find('.js-video-block-image');

        this.launchVideo();
    }

    initVideo(id, idBlock, vimeoPlayer, idx) {
        this['player' + idx] = new Vimeo.Player(idBlock, {
            id: id,
            // autoplay: this.isSmartphone() ? false : true,
            autoplay: vimeoPlayer ? false : true,
            muted: vimeoPlayer ? false : true,
            autopause: false,
            controls: vimeoPlayer ? true : false,
            loop: vimeoPlayer ? false :true,
            transparent: false,
            playsinline: false
        });

        // Запоминаем длительность видео
        this['player' + idx].getDuration().then((duration) => {
            this['videoDuration' + idx] = duration;
        });


        // Прогресс-бар
        this['player' + idx].on('timeupdate', (data) => {
            this.$progressLine.eq(idx).css({
                width: `${data.percent * 100}%`
            });
        });


        // Буфферизация
        this['player' + idx].on('progress', (data) => {
            this.$progressBuffer.eq(idx).css({
                width: `${data.percent * 100}%`
            });
        });

        this.bindVimeoControls(idx);
    }

    // Кастомные контролы Vimeo
    bindVimeoControls(idx) {
        App.H.off('.vimeo');

        // Pause/Play
        this.$videoBlockPause.eq(idx).on('click', () => {
            this['player' + idx].getPaused().then((paused) => {
                if (paused) {
                    this['player' + idx].play();
                    /*if (this.isSmartphone()) {
                        this.$videoContainer.find('iframe')[0].webkitRequestFullScreen();
                    }*/
                } else {
                    this['player' + idx].pause();
                }
            });
        });


        // Перемотка кликом по прогресс-бару
        this.$progressBar.eq(idx).on('click', (e) => {
            // Координаты клика в пикселях
            const x = e.pageX - this.$progressBar.eq(idx).offset().left;

            // Координаты клика в пропорции
            const p = x / this.$progressBar.eq(idx).width();

            // Координаты клика в секундах
            const s = this['videoDuration' + idx] * p;

            this['player' + idx].setCurrentTime(s);
        });
    }

    launchVideo () {
        App.H.ready(() => {
            let videoBlocks = $('.js-video-block');

            for (let i = 0; i < videoBlocks.length; i++) {
                let $self = $(videoBlocks[i]);

                const id = $self.data('id');
                const idBlock = $self.data('id-block');
                const vimeoPlayer = $self.data('vimeo-player');
                const ratio = $self.data('ratio');

                {
                    let h = 0.5625;   // По умолчанию соотношение 16:9 = 56,25%

                    if (ratio) {
                        try {
                            // Если указаны пропорции, считаем высоту
                            const r = ratio.split(':');
                            h = r[1] / r[0];
                        } catch (error) {}
                    }

                    $self.parent().css({
                        'padding-top': h * 100 + '%'
                    });
                }

                if (id) {
                    this.initVideo(id, idBlock, vimeoPlayer, i);
                }
            }
        });
    }

    isSmartphone() {
        return App.H.width() < 768;
    }
}

$('.js-sound-switch').click(() => {
    let $video = App.H.find('.video').find('video');
    App.H.toggleClass('_sound-on');
    if(App.H.hasClass('_sound-on')) {
        $video.prop('muted', false);
    } else {
        $video.prop('muted', true);
    }
});

App.W.on('barba:afterEnter', () => {
    videoObj = new VideoBlock();

    let players = Array.from($('.js-plyr')).map(function (el) {
        return new Plyr(el, {
            muted: true,
            loop: {
                active: $(el).data('loop') || false
            },
            // autoplay: $(el).data('autoplay') || false,
            autoplay: false,
        });
    });
});

App.W.on('barba:leave', () => {
    try {
        videoObj.destroy();
    } catch(error) { }
});


// WEBPACK FOOTER //
// ./_src/js/modules/VideoBlock.js